module.exports = __webpack_public_path__ + "img/order-ticket.6d3282b7.svg";